// extracted by mini-css-extract-plugin
export var displayNone = "_o0-6";
export var imgContainer = "_o0-2";
export var overflowHidden = "_o0-3";
export var productInfoCardButtonContainer = "_o0-5";
export var productTitleText = "_o0-4";
export var rightArrow = "_o0-1";
export var rightArrowContainer = "_o0-0";